import { createAction } from '@reduxjs/toolkit';

export const setElement = createAction('element/set_element');
export const setElements = createAction('element/set_elements');
export const deleteElement = createAction('element/delete_element');
